import { createContext } from 'react';
import { SMSConsentData } from '@src/@types/sms';

export const SMSConsentDataContext = createContext<SMSConsentData>(
  {} as SMSConsentData,
);
